import { render, staticRenderFns } from "./TheFotograflar.vue?vue&type=template&id=abe4c402&scoped=true"
import script from "./TheFotograflar.vue?vue&type=script&lang=js"
export * from "./TheFotograflar.vue?vue&type=script&lang=js"
import style0 from "./TheFotograflar.vue?vue&type=style&index=0&id=abe4c402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe4c402",
  null
  
)

export default component.exports